<template>
  <div>
    <div class="_mgbt-16px _fs-3 _tal-ct _tal-l-sm"><strong>วิธีติดตั้ง Biomatic</strong></div>
    <div class="_bgcl-neutral-300 _bdrd-2px _pdh-16px _pdv-16px">

      <p class="_mgbt-16px _fs-5 _mgt-8px"><strong>วิธีที่หนึ่ง – </strong> <a class="bio-link -fancy" href="https://github.com/BioMaRu/biomatic/releases/download/v0.1.4/biomatic.full.min.css.zip">ดาวน์โหลด CSS</a> และลิงค์ไปยัง Project ของของคุณด้วย</p>
      <pre class="_mgbt-32px"><code class="language-markup">&lt;link href="/path/to/biomatic.css" rel="stylesheet"&gt;</code></pre>

      <p class="_mgbt-16px _fs-5"><strong>วิธีที่สอง – </strong> ติดตั้งผ่าน npm หรือ yarn</p>
      <pre class="_mgbt-8px"><code class="language-markup">npm install biomatic</code></pre>
      <pre class="_mgbt-8px"><code class="language-markup">yarn add biomatic</code></pre>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HomeGettingStartSetup'
  }
</script>



// WEBPACK FOOTER //
// HomeGettingStartSetup.vue?d57ef324